import React, { useEffect, useState } from "react";
import { PrimaryButton } from "../../UI";
import { useUserContext } from "../../../contexts/UserContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SuccessAlert from "../../UI/Alert/SuccessAlert";
import Label from "../../UI/Label";
import Loader from "../../UI/Loader/Loader";
import { Field, Form, Formik } from "formik";
import { AddSMTPTaskSchema } from "../../../schemas";
import Dropdown from "../../UI/Dropdown/Dropdown";
import { getSavedTasks, saveTask, updateTask } from "../../../utils/APIs";
import { useContentfulContext } from "../../../contexts/ContentfulContext";

const ValidateSMTP = () => {
    const { userData } = useUserContext();
    const { content } = useContentfulContext();

    const { pathname } = useLocation();
    const { saved_task_id } = useParams()
    const navigate = useNavigate()

    const [showSuccess, setShowSuccess] = useState("");
    const [showError, setShowError] = useState("");
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState();

    useEffect(() => {
        if(saved_task_id) getSavedTasksDataById()
    }, [])
    
    const getSavedTasksDataById = async () => {
        try {
            setLoading(true);
            const result = await getSavedTasks(
                userData?.token,
                userData?.selectedOrganization?.org_token,
                saved_task_id
            );
            setData(result.data[0]);
        } catch (error) {
            console.log("error getSavedTasksDataById: ", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (values) => {
        try {
            setLoading(true);
            setShowError("");
            let result;

            if(saved_task_id) {
                const data = {
                    time_interval: values?.time_interval,
                    status: values?.status,
                    recipient_emails: values?.recipient_emails
                };
                result = await updateTask(
                    userData.token,
                    userData.selectedOrganization.org_token,
                    { id: saved_task_id, data }
                );
            } else {
                const data = {
                    feature_id: content.products.user_management.id,
                    saved_task_name: values.saved_task_name,
                    task_id: pathname.split('/').pop(),
                    adobe_io_integration_id: userData?.defaultAdobeIO?._id,
                    time_interval: values.time_interval,
                    status: values.status,
                    recipient_emails: values.recipient_emails
                };
                result = await saveTask(
                    userData.token,
                    userData.selectedOrganization.org_token,
                    data
                );
            }
            setShowSuccess(result.message);
            navigate("/functions/saved-tasks")
        } catch (error) {
            setShowError(error?.message || content?.COMMON_MESSAGE.something_wrong_msg);
        } finally {
            setLoading(false);
        }
    }

  return (
    <>
      <div className="w-full max-w-screen px-4 md:px-8 my-6">
        {loading && <Loader />}
        {showSuccess && (
          <SuccessAlert disappearTime={content.VALIDATE_SMTP_CONTENT.timeout}>
            {content.VALIDATE_SMTP_CONTENT.success}
          </SuccessAlert>
        )}
        <div className="flex flex-col lg:w-1/2 justify-center items-start">
          <div className="space-y-4 md:space-y-6 w-full">
            <Formik
                enableReinitialize
                initialValues={{
                    saved_task_name: data?.saved_task_name ? data?.saved_task_name : "",
                    time_interval: data?.time_interval || "",
                    status: data?.status || "",
                    email: "",
                    recipient_emails: data?.recipient_emails || [],
                }}
                validationSchema={() => AddSMTPTaskSchema(content.VALIDATE_SMTP_CONTENT)}
                onSubmit={handleSubmit}
            >
                {({ errors, touched, setFieldValue, values }) => (
                    <Form action="#">
                        <h2 className="text-xl font-bold leading-tight tracking-tight text-black text-left mb-4">
                            {content.VALIDATE_SMTP_CONTENT.title}
                        </h2>
                        <p>{content.VALIDATE_SMTP_CONTENT.description}</p>
                        <div className="my-4">
                            <div className="relative">
                                <Field
                                    type="text"
                                    id="saved_task_name"
                                    name="saved_task_name"
                                    class="block px-2.5 pb-2.5 pt-2.5 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-2 appearance-none focus:outline-none focus:ring-1 focus:ring-primary-2 ring-primary peer"
                                    placeholder=" "
                                    disabled={saved_task_id}
                                />
                                <Label labelFor="saved_task_name">{content.VALIDATE_SMTP_CONTENT.formLabels.saved_task_name}</Label>
                            </div>
                            {errors.saved_task_name && touched.saved_task_name ? (
                            <p className="mt-2 text-sm text-red-5">{errors.saved_task_name}</p>
                            ) : null}
                        </div>
                        <div className="my-4">
                                      <div className="flex flex-col sm:flex-row gap-4 md:gap-8">
                                          <div className="flex flex-col w-full sm:w-auto">
                                              <div className="relative">
                                                  <Dropdown
                                                      width={window.innerWidth < 640 ? "100%" : "270"}
                                                      initialValue={content.CRON_TIME_INTERVAL.find(x => x.value == values.time_interval)}
                                                      items={content.CRON_TIME_INTERVAL}
                                                      callback={(val) => setFieldValue("time_interval", val.value)}
                                                  />
                                                  <Label labelFor="time_interval">{content.VALIDATE_SMTP_CONTENT.formLabels.time_interval}</Label>
                                              </div>
                                              {errors.time_interval && touched.time_interval ? (
                                                  <p className="mt-2 text-sm text-red-5">{errors.time_interval}</p>
                                              ) : null}
                                          </div>
                                          <div className="flex flex-col w-full sm:w-auto">
                                              <div className="relative">
                                                  <Dropdown
                                                      width={window.innerWidth < 640 ? "100%" : "270"}
                                                      initialValue={content.LAMBDA_STATUS_VALUES.find(x => x.value == values.status)}
                                                      items={content.LAMBDA_STATUS_VALUES}
                                                      callback={(val) => setFieldValue("status", val.value)}
                                                  />
                                                  <Label labelFor="status">{content.VALIDATE_SMTP_CONTENT.formLabels.status}</Label>
                                              </div>
                                              {errors.status && touched.status ? (
                                                  <p className="mt-2 text-sm text-red-5">{errors.status}</p>
                                              ) : null}
                                          </div>
                                      </div>
                        </div>
                        <div className="my-4">
                        </div>
                        <div className="my-4">
                            <div className="relative">
                                <Field
                                    type="text"
                                    id="email"
                                    name="email"
                                    class="block px-2.5 pb-2.5 pt-2.5 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-2 appearance-none focus:outline-none focus:ring-1 focus:ring-primary-2 ring-primary peer"
                                    placeholder=" "
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            if(!errors.email) {
                                                setFieldValue('recipient_emails', [...values.recipient_emails, e.target.value]);
                                                setFieldValue('email', '');
                                            }
                                        }
                                    }}
                                />
                                <Label labelFor="email">{content.VALIDATE_SMTP_CONTENT.formLabels.email}</Label>
                            </div>
                            {errors.email && touched.email ? (
                                <p className="mt-2 text-sm text-red-5">{errors.email}</p>
                            ) : null}
                            {!errors.email && errors.recipient_emails && touched.recipient_emails ? (
                            <   p className="mt-2 text-sm text-red-5">{errors.recipient_emails}</p>
                            ) : null}
                            {values.recipient_emails.length >0  && <ul className="max-h-[200px] max-w-[450px] overflow-y-auto my-4 border border-gray-2 rounded-lg ">
                                {values.recipient_emails.map((x, i) => (
                                    <li key={i} className="p-3 flex justify-between w-full border-b border-gray-2">
                                        {x}
                                        <button
                                            type="button"
                                            className="text-red-5"
                                            onClick={() => {
                                                const newRecipientEmails = [...values.recipient_emails];
                                                newRecipientEmails.splice(i, 1);
                                                setFieldValue('recipient_emails', newRecipientEmails);
                                            }}
                                        >x</button>
                                    </li>
                                ))}
                            </ul>}
                        </div>
                        {showError && <p className="my-2 text-sm text-red-5">{showError}</p>}
                                    <div className="flex justify-end mt-6">
                                        <PrimaryButton type="submit" className="w-full sm:w-auto">
                                            {content.VALIDATE_SMTP_CONTENT.submit_cta}
                                        </PrimaryButton>
                                    </div>
                    </Form>
                )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default ValidateSMTP;
